export default __webpack_public_path__ + "static/media/thrash.5fb9c746.svg";